<template>
	<div class="side-by-side__caption">
		{{ item.caption }}
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.side-by-side {
	&__caption {
		margin-top: 1rem;
		text-transform: uppercase;
		font-weight: 400;
		font-size: 16px;
		text-decoration: none;
		@include respond-below('phone') {
			margin: 1rem 0;
		}
	}
}
</style>
